package ru.villawonka.app.domain.model

enum class CountryDomain {
    INDONESIA,
    THAILAND,
    VIETNAM
}